export const MPMKVVCL_CONNECT_SET_USER = 'MPMKVVCL_CONNECT_SET_USER';
export const MPMKVVCL_CONNECT_RESET = 'MPMKVVCL_CONNECT_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
